import directStores from './direct_stores.vue';

export default directStores;
